import { GridInitialState } from '@mui/x-data-grid-premium'

// While grouping is active the pinned-left leaf is folded to hidden so its value only renders in the
// grouping column. That fold is a render-time derivation from the grouping model, not a user preference —
// persisting it leaves the leaf stuck hidden after ungrouping (it has no toggle when hideable:false).
export const stripPersistedGroupingLeafFold = (state: GridInitialState, leafField: string | undefined): GridInitialState => {
  const visibilityModel = state.columns?.columnVisibilityModel
  if (!leafField || !visibilityModel || visibilityModel[leafField] !== false) return state

  const { [leafField]: _folded, ...remaining } = visibilityModel
  return { ...state, columns: { ...state.columns, columnVisibilityModel: remaining } }
}
